'use strict';

var Backbone = require('backbone');
var _ = require('underscore');
var config = require('../../js/config');
var utilities = require('../../js/utilities');
var loaderTemplate = require('../../tmpl/client/loader.hbs');
var mediator = require('../../js/mediator');
var errorTemplate = require('../../tmpl/client/_defaultError.hbs');
var MegaMenuItemCollection = require('./MegaMenuItemCollection');
import {parallelArrayEach} from '../../utilities/uiLoopHelpers';

let MegaMenuListView = Backbone.View.extend({
  previouslyLoaded: false,
  template: require('./templates/_MegaMenuAjaxList.hbs'),

  initialize: function(options) {
    _.extend(this, options);
    this.$parent = this.$el.closest('.megamenu-tab');
    this.collection = new MegaMenuItemCollection({
      url: this.$el.data('endpoint')
    });
    this.$html = this.$el.html();
    this.$el.html(loaderTemplate());
    mediator.on(config.events.megaMenu.open, this.loadItems, this);
    this.loadItems();
  },

  loadItems: function() {
    if (this.$parent.hasClass('megamenu-open') && !this.previouslyLoaded) {
      this.previouslyLoaded = true;
      this.collection.fetch({ handleErrorLocally: true, data: utilities.addCustIpToDataObject({}) })
        .success(() => {
          let isDesignCenter = this.$el.data('design-center'),
            results = this.collection.toJSON(),
            analyticsSection = this.$el.data('section');

          if (!_.isEmpty(results)) {
            this.$el.html(this.template({
              icon: this.$el.data('icon'),
              'title-url': this.$el.data('title-url'),
              'design-center': isDesignCenter,
              results,
              analyticsSection,
              analytics: config.analytics
            }));
          } else {
            if (isDesignCenter) {
              this.$el.html(this.$html);
              return;
            }
            this.$el.html('')
              .siblings('.NewList-Copy')
              .removeClass('u-hide');
          }

        })
        .error(function() {
          this.$el.html(errorTemplate);
        });
    }
  }
});

export function create($parent) {
  parallelArrayEach($parent.find('.MegaMenuAjaxList'), (el) => new MegaMenuListView({ el: el }));
}



// WEBPACK FOOTER //
// ./assets/components/MegaMenuAjaxList/MegaMenuAjaxListView.js